import TabEmptyState from "_components/atoms/tabEmptyState";
import VideoCardList from "_components/organisms/videoCardList/container";

import CreatorCards    from "../creatorCards";
import LiveStreamCards from "../liveStreamCards";

const component = ( { tab, data, fetchMore, isDepleted, isLoading } ) => {

	function getCardType ( type ) {
		if ( type === "reels" )
			return "reel";
		if ( type === "live" )
			return "stream";
		if ( type === "video" )
			return "videos";

		else return "stream";
	}

	if ( !data?.length ) return <TabEmptyState />;

	if ( tab === "reels" ) {
		return (
			<VideoCardList
				activeTab         = { "reels" }
				cardType          = { "reel" }
				from              = { "profileReelTab" }
				list              = { data }
			/>
		);
	}

	if ( tab === "videos" || tab === "live" ) {
		return (
			<LiveStreamCards
				cardType   = { getCardType ( tab ) }
				data       = { data }
				fetchMore  = { fetchMore }
				isDepleted = { isDepleted }
				isLoading  = { isLoading }
			/>
		);
	}

	if ( tab === "people" ) {
		return (
			<CreatorCards
				data       = { data }
				fetchMore  = { fetchMore }
				isDepleted = { isDepleted }
				isLoading  = { isLoading }
			/>
		);
	}

	return (
		null
	);
};

export default component;